import Cookies from "js-cookie";

const cookieEvent = new CustomEvent("cookieChanged", {
  bubbles: true,
  detail: {
    cookieValue: JSON.stringify(Cookies.get("KL_FORMS_MODAL")),
    checkChange: () => {
      if (
        cookieEvent.detail.cookieValue !=
          JSON.stringify(Cookies.get("KL_FORMS_MODAL")) &&
        typeof Cookies.get("KL_FORMS_MODAL") !== "undefined"
      ) {
        cookieEvent.detail.cookieValue = JSON.stringify(
          Cookies.get("KL_FORMS_MODAL")
        );
        return 1;
      } else {
        return 0;
      }
    },
    listenCheckChange: () => {
      setInterval(function() {
        if (cookieEvent.detail.checkChange() == 1) {
          cookieEvent.detail.changed = true;
          //fire the event
          cookieEvent.target.dispatchEvent(cookieEvent);
        } else {
          cookieEvent.detail.changed = false;
        }
      }, 200);
    },
    changed: false,
  },
});

export default cookieEvent;
